import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { translate } from 'react-i18next';
import { Row, Col, Card, FormGroup, Label, Input, Button, CardBody } from 'reactstrap';
import { StripeProvider } from 'react-stripe-elements';
import Checkout from '../Checkout';
import stripeBadge from '../Checkout/powered_by_stripe.png';
import AddressSection from '../Checkout/AddressSection';
import VoucherSection from '../Checkout/VoucherSection';
import PromoCodeSection from '../Checkout/PromoCodeSection';
import Payment from '../Store/Payment';
import Settings from '../Store/Settings';

@observer
class CheckoutSection extends Component {

  handlePaymentTypeChange = (e) => {
    const {
      booking,
    } = this.props;

    const type = booking.payment_types.find(p => p.id == e.target.value);

    // update payment type, but keep token
    booking.payment = new Payment({
      ...type,
      token: booking.payment.token,
    });
  };

  render() {
    const { t, booking, handlePayment } = this.props;
    const hasVoucherOrPromo = booking.voucher || (booking.promo_code && Settings.settings.get('enable_promo_codes'));

    return (
      <div>
        <Row className='align-items-stretch mb-4'>
          <Col md={hasVoucherOrPromo ? '8' : '12'}>
            <Card style={{ height: '100%' }}>
              <CardBody>
                <h2>3. {t('Rechnungsinformationen')}</h2>
                <AddressSection booking={booking} />
              </CardBody>
            </Card>
          </Col>
          {hasVoucherOrPromo && (
            <Col md='4'>
              <Card style={{ height: '100%' }}>
                <CardBody>
                  <h2>4. {t('Certificates')}</h2>
                  {booking.voucher &&
                    <div>
                      <VoucherSection booking={booking} />
                      <div style={{ width: '100%' }} className='mb-4 separator'></div>
                    </div>}
                  {booking.promo_code && Settings.settings.get('enable_promo_codes') &&
                      <PromoCodeSection booking={booking} />
                  }
                </CardBody>
              </Card>
            </Col>
          )}
        </Row>
        <Row className='align-items-stretch mb-4'>
          <Col md='8' className='mb-4 mb-md-0'>
            <Card style={{ height: '100%' }}>
              <CardBody>
                <h2>{hasVoucherOrPromo ? '5' : '4'}. {t('Payment Method')}</h2>
                <Row>
                  <Col lg={6} className='mb-4 mb-md-0 pt-2'>
                    {booking.payment_types.map(pt => (
                      <FormGroup key={pt.name} check>
                        <Label check>
                          <Input
                            checked={booking.payment.id === pt.id}
                            type='radio'
                            name='payment_type'
                            value={pt.id}
                            onChange={this.handlePaymentTypeChange}
                            disabled={booking.actualPrice == 0}
                          />{' '}
                          {pt.title || t(pt.name)}
                          {
                            pt.name == 'ONLINE' &&
                            <span>{' '}<img style={{ height: '1.5em' }} src={stripeBadge} /></span>
                          }
                        </Label>
                      </FormGroup>
                    ))}
                  </Col>
                  <Col lg={6}>
                    {
                      booking.payment.name == 'ONLINE' && booking.payment.stripe_public_key &&
                      <StripeProvider apiKey={booking.payment.stripe_public_key}>
                        <Checkout
                          booking={booking}
                          handlePayment={handlePayment}
                          buttonText={this.props.buttonText}
                          showSubmitButton={this.props.showSubmitButton}
                        />
                      </StripeProvider>
                    }
                    {
                      booking.payment.name == 'ONLINE' && !booking.payment.stripe_public_key &&
                      <div className="alert alert-warning">
                        Stripe is not configured properly. Please contact support.
                      </div>
                    }
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
          <Col md='4'>
            <Card style={{ height: '100%' }}>
              <CardBody>
                <h2>{t('Summary')}</h2>
                {
                  booking.paymentMethodCommission > 0 &&
                  <div>
                    <div className='text-dark mb-4'>
                      <Row>
                        <Col xs={7}>{t('Subtotal')}:</Col>
                        <Col xs={5} className='text-right'>{booking.actualPrice.toFixed(2)} {booking.currency}</Col>
                      </Row>
                      <Row>
                        <Col xs={7}>{t('Credit card commission')}:</Col>
                        <Col xs={5}
                             className='text-right'>{booking.paymentMethodCommission.toFixed(2)} {booking.currency}</Col>
                      </Row>
                    </div>
                    <div className='separator mb-4'></div>
                  </div>
                }
                <Row>
                  <Col xs={6}><h3>{t('Gesamtpreis')}:</h3></Col>
                  <Col xs={6} className='text-right'><h3>{booking.getPriceToPay().toFixed(2)} {booking.currency}</h3>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

export default translate()(CheckoutSection);



// WEBPACK FOOTER //
// ./src/App/Booking/CheckoutSection.js